"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isApplicationStatusOutcomeShareable = exports.isApplicationStatusOutcome = exports.isApplicationStatusApproval = exports.WaitlistType = exports.SMBYearsInBusiness = exports.SMBRoleType = exports.SMBOwnershipStake = exports.SMBIndustryType = exports.SMBStructure = exports.SMBCompanySize = exports.IncomeSource = exports.ApprovalOfferType = exports.ApprovalOfferResponse = exports.ApplyFlowVariation = exports.ApplicationStatus = exports.ApplicationsError = exports.ApplicationsEndpoints = void 0;
var ApplicationsEndpoints;
(function (ApplicationsEndpoints) {
    ApplicationsEndpoints["CheckWaitlist"] = "/applications/check-waitlist";
    ApplicationsEndpoints["DeleteApplication"] = "/applications/delete-application";
    ApplicationsEndpoints["GetApplicationStatus"] = "/applications/get-application-status";
    ApplicationsEndpoints["GetApprovalOffers"] = "/applications/get-approval-offers";
    ApplicationsEndpoints["GetPlaidIdentityLinkToken"] = "/applications/get-plaid-identity-link-token";
    ApplicationsEndpoints["GetProductLaunchStatus"] = "/applications/get-product-launch-status";
    ApplicationsEndpoints["ManageOffer"] = "/applications/manage-offer";
    ApplicationsEndpoints["PrefillPartnerApplication"] = "/applications/partners/prefill-partner-application";
    ApplicationsEndpoints["ShouldVerifyPhone"] = "/applications/should-verify-phone";
    ApplicationsEndpoints["Ssn4ToSsn9"] = "/applications/ssn4-to-ssn9";
    ApplicationsEndpoints["SubmitApplication"] = "/applications/submit-application";
    ApplicationsEndpoints["SubmitIdentityVerification"] = "/applications/submit-identity-verification";
    ApplicationsEndpoints["VerifyPrescreenedIdentity"] = "/applications/verify-prescreened-identity";
})(ApplicationsEndpoints || (exports.ApplicationsEndpoints = ApplicationsEndpoints = {}));
var WaitlistType;
(function (WaitlistType) {
    /** product is no longer in waitlist mode */
    WaitlistType["WAITLIST_TYPE_UNSPECIFIED"] = "WAITLIST_TYPE_UNSPECIFIED";
    WaitlistType["EARLY_ACCESS"] = "EARLY_ACCESS";
    WaitlistType["FRIENDS_AND_FAMILY"] = "FRIENDS_AND_FAMILY";
    WaitlistType["PUBLIC"] = "PUBLIC";
})(WaitlistType || (exports.WaitlistType = WaitlistType = {}));
var ApplicationStatus;
(function (ApplicationStatus) {
    /**
     * Application decision pending.
     *
     * This usually means that the identity, fraud, credit, etc
     * checks are still being run by 3rd party vendors
     */
    ApplicationStatus["InProgress"] = "IN_PROGRESS";
    /**
     * Application has been approved by KYC/AML and underwriting, but pending
     * resource setup (user, account, and physical/virtual cards).
     */
    ApplicationStatus["ApprovedPendingResourceCreation"] = "APPROVED_PENDING_RESOURCE_CREATION";
    /** Application has been approved */
    ApplicationStatus["Approved"] = "APPROVED";
    /**
     * Application has been approved by KYC/AML and underwriting, but failed at
     * resource setup (user, account, and physical/virtual cards)
     */
    ApplicationStatus["ApprovedFailedResourceCreation"] = "APPROVED_FAILED_RESOURCE_CREATION";
    /** In a 2-step flow, where the application is approved but the user declined the offer */
    ApplicationStatus["ApprovedOfferDeclined"] = "APPROVED_OFFER_DECLINED";
    /** In a 2-step flow, where the application is approved but the offer to accept has been expired */
    ApplicationStatus["ApprovedOfferExpired"] = "APPROVED_OFFER_EXPIRED";
    /** In a 2-step flow, where the application is approved but the user must accept */
    ApplicationStatus["ApprovedPendingAcceptance"] = "APPROVED_PENDING_ACCEPTANCE";
    /**
     * In cases where we need to resume an application ({@link ApplicationStatus.SystemFailure},
     * {@link ApplicationStatus.CreditFrozenOrLockedFile}, etc), we mark the original application
     * as {@link ApplicationStatus.Archived} so that it's easy to filter them out in feature
     * engineering and analytics.
     */
    ApplicationStatus["Archived"] = "ARCHIVED";
    /**
     * For business card applications, we want to send all applicants approved in underwriting
     * through effectiv's KYB workflow, which includes prescreening & onboarding
     */
    ApplicationStatus["BusinessPrescreening"] = "BUSINESS_PRESCREENING";
    /**
     * For business card applications, we want to send all applicants approved in underwriting
     * through effectiv's KYB workflow
     */
    ApplicationStatus["BusinessOnboarding"] = "BUSINESS_ONBOARDING";
    /** Application has been cancelled and there is no need for an AAN */
    ApplicationStatus["Cancelled"] = "CANCELLED";
    /** Application has been declined */
    ApplicationStatus["Declined"] = "DECLINED";
    /**
     * Application requires review.
     *
     * Additional supporting documentation could be required,
     * and a manual review might be necessary
     */
    ApplicationStatus["ReviewRequired"] = "REVIEW_REQUIRED";
    /** User is in identity verification review (i.e. Plaid document verification) */
    ApplicationStatus["IdentityVerificationReview"] = "IDENTITY_VERIFICATION_REVIEW";
    /**
     * Some of our vendors can have scheduled downtime, and this can affect
     * Applications service's ability to process new applications. However, it
     * should still accept new incoming applications, but queue up for later
     * processing once the vendor is back online. A new status is added here to
     * help reflect whether the application is currently in maintenance state
     * waiting for vendor to get back online
     */
    ApplicationStatus["InMaintenance"] = "IN_MAINTENANCE";
    /**
     * Credit is frozen or locked file. In this state, the application is
     * neither declined nor approved. We simply need to let the applicant knows
     * that we cannot pull the credit report and cannot make a decision.
     *
     * The follow up is usually making a suggestion to the applicant to call
     * their credit bureaus to unfreeze their credits, revisit the site and re-apply.
     */
    ApplicationStatus["CreditFrozenOrLockedFile"] = "CREDIT_FROZEN_OR_LOCKED_FILE";
    /**
     * Application faces some system failure on backend.
     * This requires backend engineering team to investigate.
     */
    ApplicationStatus["SystemFailure"] = "SYSTEM_FAILURE";
    /**
     * Application has begun the screening phase of the submission process,
     * where we perform identity or KYC verification. If flagged for any reason,
     * application will require a manual review and may be in this phase for an extended period.
     */
    ApplicationStatus["Screening"] = "SCREENING";
    /**
     * Application has begun the underwriting phase of the submission process,
     * where we perform a risk assessment. If within an uncertain risk threshold,
     * application will require a manual review and may be in this phase for an extended period.
     */
    ApplicationStatus["Underwriting"] = "UNDERWRITING";
    /** Internal, FE usage only */
    ApplicationStatus["_ShareableNonApproval"] = "OTHER";
})(ApplicationStatus || (exports.ApplicationStatus = ApplicationStatus = {}));
const isApplicationStatusOutcome = (applicationStatus) => !!applicationStatus &&
    [
        ApplicationStatus.Approved,
        ApplicationStatus.ApprovedFailedResourceCreation,
        ApplicationStatus.CreditFrozenOrLockedFile,
        ApplicationStatus.Declined,
        ApplicationStatus.InMaintenance,
        ApplicationStatus.ReviewRequired,
        ApplicationStatus.SystemFailure,
    ].includes(applicationStatus);
exports.isApplicationStatusOutcome = isApplicationStatusOutcome;
/**
 * Not all statuses are legally shareable to partner(s) based
 * on Cardless privacy policy
 */
const isApplicationStatusOutcomeShareable = (applicationStatus) => !!applicationStatus &&
    [
        ApplicationStatus.Approved,
        ApplicationStatus.ApprovedFailedResourceCreation,
        ApplicationStatus.Declined,
    ].includes(applicationStatus);
exports.isApplicationStatusOutcomeShareable = isApplicationStatusOutcomeShareable;
const isApplicationStatusApproval = (applicationStatus) => !!applicationStatus &&
    [
        ApplicationStatus.Approved,
        ApplicationStatus.ApprovedFailedResourceCreation,
    ].includes(applicationStatus);
exports.isApplicationStatusApproval = isApplicationStatusApproval;
/*
 * Income source of the applicant
 */
var IncomeSource;
(function (IncomeSource) {
    IncomeSource["Unspecified"] = "INCOME_SOURCE_UNSPECIFIED";
    IncomeSource["Employed"] = "EMPLOYED";
    IncomeSource["Retired"] = "RETIRED";
    IncomeSource["SelfEmployed"] = "SELF_EMPLOYED";
    IncomeSource["Unemployed"] = "UNEMPLOYED";
    IncomeSource["Military"] = "MILITARY";
    IncomeSource["Other"] = "OTHER";
})(IncomeSource || (exports.IncomeSource = IncomeSource = {}));
var SMBStructure;
(function (SMBStructure) {
    SMBStructure["Corporation"] = "CORPORATION";
    SMBStructure["MultiMemberLLC"] = "MULTI_MEMBER_LLC";
    SMBStructure["NonProfit"] = "NON_PROFIT";
    SMBStructure["Partnership"] = "PARTNERSHIP";
    SMBStructure["SingleMemberLLC"] = "SINGLE_MEMBER_LLC";
    SMBStructure["SoleProprietorship"] = "SOLE_PROPRIETORSHIP";
    SMBStructure["Unspecified"] = "SMB_BUSINESS_STRUCTURE_UNSPECIFIED";
})(SMBStructure || (exports.SMBStructure = SMBStructure = {}));
var SMBIndustryType;
(function (SMBIndustryType) {
    SMBIndustryType["ArtsOrEntertainment"] = "ARTS_OR_ENTERTAINMENT";
    SMBIndustryType["Finance"] = "FINANCE";
    SMBIndustryType["InsuranceServices"] = "INSURANCE_SERVICES";
    SMBIndustryType["Manufacturing"] = "MANUFACTURING";
    SMBIndustryType["RealEstate"] = "REAL_ESTATE";
    SMBIndustryType["Retail"] = "RETAIL";
    SMBIndustryType["Wholesale"] = "WHOLESALE";
    SMBIndustryType["Other"] = "SMB_INDUSTRY_TYPE_OTHER";
    SMBIndustryType["Unspecified"] = "SMB_INDUSTRY_TYPE_UNSPECIFIED";
})(SMBIndustryType || (exports.SMBIndustryType = SMBIndustryType = {}));
var SMBRoleType;
(function (SMBRoleType) {
    SMBRoleType["Owner"] = "OWNER";
    SMBRoleType["Partner"] = "PARTNER";
    SMBRoleType["President"] = "PRESIDENT";
    SMBRoleType["Treasurer"] = "TREASURER";
    SMBRoleType["VicePresident"] = "VICE_PRESIDENT";
    SMBRoleType["Other"] = "SMB_ROLE_TYPE_OTHER";
    SMBRoleType["Unspecified"] = "SMB_ROLE_TYPE_UNSPECIFIED";
})(SMBRoleType || (exports.SMBRoleType = SMBRoleType = {}));
var SMBCompanySize;
(function (SMBCompanySize) {
    SMBCompanySize["Size_1_25"] = "COMPANY_SIZE_1_25";
    SMBCompanySize["Size_26_100"] = "COMPANY_SIZE_26_100";
    SMBCompanySize["Size_101_250"] = "COMPANY_SIZE_101_250";
    SMBCompanySize["Size_251_500"] = "COMPANY_SIZE_251_500";
    SMBCompanySize["Size_501_Infinity"] = "COMPANY_SIZE_501_INFINITY";
    SMBCompanySize["Unspecified"] = "SMB_COMPANY_SIZE_UNSPECIFIED";
})(SMBCompanySize || (exports.SMBCompanySize = SMBCompanySize = {}));
var SMBOwnershipStake;
(function (SMBOwnershipStake) {
    SMBOwnershipStake["LT_25"] = "LT_25";
    SMBOwnershipStake["GTE_25"] = "GTE_25";
    SMBOwnershipStake["Unspecified"] = "SMB_OWNERSHIP_STAKE_UNSPECIFIED";
})(SMBOwnershipStake || (exports.SMBOwnershipStake = SMBOwnershipStake = {}));
var SMBYearsInBusiness;
(function (SMBYearsInBusiness) {
    SMBYearsInBusiness["Unspecified"] = "SMB_YEARS_IN_BUSINESS_UNSPECIFIED";
    SMBYearsInBusiness["Years_LT1"] = "YEARS_IN_BUSINESS_LESS_THAN_1";
    SMBYearsInBusiness["Years_1_2"] = "YEARS_IN_BUSINESS_1_2";
    SMBYearsInBusiness["Years_2_5"] = "YEARS_IN_BUSINESS_2_5";
    SMBYearsInBusiness["Years_5_10"] = "YEARS_IN_BUSINESS_5_10";
    SMBYearsInBusiness["Years_10_Infinity"] = "YEARS_IN_BUSINESS_10_INFINITY";
})(SMBYearsInBusiness || (exports.SMBYearsInBusiness = SMBYearsInBusiness = {}));
/**
 * Error codes in the `applications` namespace
 * @see https://github.com/cardlesshq/java/blob/43998656f843af4d828319c3cc3ed235eec3c4b4/proto-registry/cardless/proto/applications/api/applications.proto
 */
var ApplicationsError;
(function (ApplicationsError) {
    ApplicationsError["Unspecified"] = "APPLICATIONS_ERROR_UNSPECIFIED";
    ApplicationsError["InvalidFirstName"] = "INVALID_FIRST_NAME";
    ApplicationsError["InvalidLastName"] = "INVALID_LAST_NAME";
    ApplicationsError["InvalidEmail"] = "INVALID_EMAIL";
    ApplicationsError["InvalidPhone"] = "INVALID_PHONE";
    ApplicationsError["InvalidBirthDate"] = "INVALID_BIRTHDATE";
    ApplicationsError["InvalidSSN"] = "INVALID_SSN";
    ApplicationsError["InvalidAddress1"] = "INVALID_ADDRESS_LINE_1";
    ApplicationsError["InvalidAddress2"] = "INVALID_ADDRESS_LINE_2";
    ApplicationsError["InvalidZip"] = "INVALID_ZIP_CODE";
    ApplicationsError["InvalidCity"] = "INVALID_CITY";
    ApplicationsError["InvalidState"] = "INVALID_STATE_ISO2_CODE";
    ApplicationsError["InvalidCountry"] = "INVALID_COUNTRY_ISO2_CODE";
    ApplicationsError["InvalidIncome"] = "INVALID_INCOME";
    ApplicationsError["InvalidLoyaltyInfo"] = "INVALID_LOYALTY_INFO";
    ApplicationsError["InvalidMFA"] = "INVALID_MFA";
    ApplicationsError["InvalidMortgageOrRent"] = "INVALID_MONTHLY_MORTGAGE_OR_RENT";
    ApplicationsError["InvalidIncomeSource"] = "INVALID_INCOME_SOURCE";
    ApplicationsError["PhoneOccupied"] = "PHONE_OCCUPIED";
    ApplicationsError["EmailOccupied"] = "EMAIL_OCCUPIED";
    ApplicationsError["InvalidPrescreenCode"] = "INVALID_PRESCREEN_CODE";
    ApplicationsError["InvalidUpdateParams"] = "INVALID_UPDATE_PARAMS";
    ApplicationsError["ExpiredPrescreenCode"] = "EXPIRED_PRESCREEN_CODE";
    ApplicationsError["ApplicationInProgress"] = "APPLICATION_IN_PROGRESS";
    ApplicationsError["PartnerUserOccupied"] = "PARTNER_USER_OCCUPIED";
    ApplicationsError["ApprovalOfferExpired"] = "APPROVAL_OFFER_EXPIRED";
    ApplicationsError["InvalidSMBProduct"] = "INVALID_SMB_PRODUCT";
    ApplicationsError["InvalidBusinessName"] = "INVALID_BUSINESS_NAME";
    ApplicationsError["InvalidFederalTaxId"] = "INVALID_FEDERAL_TAX_ID";
    ApplicationsError["InvalidAdditionalOwner"] = "INVALID_ADDITIONAL_OWNER";
    ApplicationsError["InvalidSMBIndustry"] = "INVALID_SMB_INDUSTRY";
    ApplicationsError["InvalidSMBRole"] = "INVALID_SMB_ROLE";
    ApplicationsError["InvalidSMBStructure"] = "INVALID_SMB_STRUCTURE";
    ApplicationsError["InvalidCompanySize"] = "INVALID_COMPANY_SIZE";
    ApplicationsError["InvalidBusinessNameOnCard"] = "INVALID_BUSINESS_NAME_ON_CARD";
    ApplicationsError["InvalidYearsInBusiness"] = "INVALID_YEARS_IN_BUSINESS";
    ApplicationsError["InvalidBusinessPhone"] = "INVALID_BUSINESS_PHONE";
    ApplicationsError["InvalidBusinessAddressLine1"] = "INVALID_BUSINESS_ADDRESS_LINE_1";
    ApplicationsError["InvalidBusinessAddressLine2"] = "INVALID_BUSINESS_ADDRESS_LINE_2";
    ApplicationsError["InvalidBusinessAddressCity"] = "INVALID_BUSINESS_ADDRESS_CITY";
    ApplicationsError["InvalidBusinessAddressStateISO2Code"] = "INVALID_BUSINESS_ADDRESS_STATE_ISO2_CODE";
    ApplicationsError["InvalidBusinessAddressCountryISO2Code"] = "INVALID_BUSINESS_ADDRESS_COUNTRY_ISO2_CODE";
    ApplicationsError["InvalidBusinessAddressPostalCode"] = "INVALID_BUSINESS_ADDRESS_POSTAL_CODE";
    ApplicationsError["InvalidBusinessEmail"] = "INVALID_BUSINESS_EMAIL";
    ApplicationsError["InvalidApplicantAge"] = "INVALID_APPLICANT_AGE";
    ApplicationsError["InvalidBeneficialOwnerAge"] = "INVALID_BENEFICIAL_OWNER_AGE";
    ApplicationsError["InvalidIPAddress"] = "INVALID_IP_ADDRESS";
    ApplicationsError["InvalidContactInfo"] = "INVALID_CONTACT_INFO";
    ApplicationsError["InvalidJWT"] = "INVALID_JWT";
    ApplicationsError["InvalidProduct"] = "INVALID_PRODUCT";
    /**
     * Soft pulls: application cannot currently respond to offers
     */
    ApplicationsError["NotReady"] = "APPLICATION_NOT_READY";
    /**
     * Soft pulls: application phone and dob do not match offer phone and dob
     */
    ApplicationsError["PhoneOrDOBMisMatch"] = "PHONE_OR_DOB_NOT_MATCHING";
    /**
     * Throws when encoded user data (JWT) required, but empty/invalid
     * within submit payload
     */
    ApplicationsError["PartnerDataRequired"] = "PARTNER_DATA_REQUIRED";
})(ApplicationsError || (exports.ApplicationsError = ApplicationsError = {}));
var ApplyFlowVariation;
(function (ApplyFlowVariation) {
    ApplyFlowVariation["APPLY_FLOW_VARIATION_UNSPECIFIED"] = "APPLY_FLOW_VARIATION_UNSPECIFIED";
    ApplyFlowVariation["ONE_STEP_HARD_PULL"] = "ONE_STEP_HARD_PULL";
    ApplyFlowVariation["TWO_STEP_SOFT_PULL"] = "TWO_STEP_SOFT_PULL";
    ApplyFlowVariation["ONE_STEP_SOFT_PULL"] = "ONE_STEP_SOFT_PULL";
})(ApplyFlowVariation || (exports.ApplyFlowVariation = ApplyFlowVariation = {}));
var ApprovalOfferType;
(function (ApprovalOfferType) {
    ApprovalOfferType["OFFER_TYPE_UNSPECIFIED"] = "OFFER_TYPE_UNSPECIFIED";
    /** This offer is for the product that the user applied for */
    ApprovalOfferType["PRIMARY"] = "PRIMARY";
    /** This offer is for a different product than the one the user applied for */
    ApprovalOfferType["ALTERNATE"] = "ALTERNATE";
})(ApprovalOfferType || (exports.ApprovalOfferType = ApprovalOfferType = {}));
var ApprovalOfferResponse;
(function (ApprovalOfferResponse) {
    ApprovalOfferResponse["APPROVAL_OFFER_RESPONSE_UNSPECIFIED"] = "APPROVAL_OFFER_RESPONSE_UNSPECIFIED";
    /** The user accepted the offer */
    ApprovalOfferResponse["ACCEPTED"] = "ACCEPTED";
    /** The user declined the offer */
    ApprovalOfferResponse["DECLINED"] = "DECLINED";
    /** The user chose "Maybe Later" for their offer */
    ApprovalOfferResponse["DEFERRED"] = "DEFERRED";
})(ApprovalOfferResponse || (exports.ApprovalOfferResponse = ApprovalOfferResponse = {}));
